/**
 * Origens de captura de lead com tratamento próprio (e-mail de boas-vindas,
 * segmentação). Arquivo sem dependências — importável no client e no server.
 */

/** Ferramenta do perdão das dívidas (/perdao-dividas-mei, LC 238/2026). */
export const LEAD_SOURCE_PERDAO = 'perdao-dividas-mei'
